import React, { useState, useRef, useEffect } from "react";
import GoogleCalendarPopup from "../GoogleCalendarDemoPopup/GoogleCalendarPopUp.tsx";
import GoogleCalendarWidget from "../GoogleCalendarDemoPopup/GoogleCalendarWidget.tsx";
// import PhoneInput from "react-phone-number-input" ;
import { Box, Container, Dialog, DialogTitle, IconButton, DialogContent } from "@mui/material";
import Swal from "sweetalert2";
import { isValidPhoneNumber } from "react-phone-number-input";
import { InlineWidget, useCalendlyEventListener } from "react-calendly";
import { Close } from "@mui/icons-material";
// import DefaultInput from "../../../../components/commonComponents/input/DefaultInput";
// import DefaultButton from "../../../../components/commonComponents/buttons/DefaultButton";
interface FormData {
  firstname: string;
  lastname: string;
  email: string;
  companyName: string;
  phone: string;
}

// import { useNavigate } from "react-router-dom";
// import imageConfig from "../../../../config/imageConfig";
// import SavvyCalDemoPopup from "../../../../components/SavvyCalDemoPopup";

interface PopupProps {
  isOpen: boolean;
  onClose: () => void;
  formData: FormData; // Add formData as a prop
  handleCloseCalendlyPopup: () => void;
}

const Popup: React.FC<PopupProps> = ({ isOpen, onClose, formData, handleCloseCalendlyPopup }) => {
  useCalendlyEventListener({
    onProfilePageViewed: () => console.log("Profile page viewed"),
    onDateAndTimeSelected: () => console.log("Date and time selected"),
    onEventTypeViewed: () => console.log("Event type viewed"),
    onEventScheduled: (e) => console.log("Event scheduled:", e.data.payload),
    onPageHeightResize: (e) => console.log("Page height resized:", e.data.payload.height),
  });

  if (!isOpen) return null;

  return (
    <Dialog
      open={isOpen}
      onClose={handleCloseCalendlyPopup}
      fullWidth
      maxWidth="md"
      className="demo-popup-calendly-schedule"
    >
      <DialogTitle>
        <div className="flex justify-between items-center text-gray-700">
          <div>
            <div className="text-[18px] font-semibold">
              We have received your demo request successfully.
            </div>
            <div className="text-[14px] font-medium">Book your own time slot.</div>
          </div>
          <IconButton onClick={handleCloseCalendlyPopup}>
            <Close />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent>
        <InlineWidget
          url="https://savvycal.com/harshdeep/1381cd4b"
          prefill={{
            name: `${formData.firstname} ${formData.lastname}`,
            email: formData.email,
          }}
          styles={{
            minWidth: "520px",
            height: "700px",
            borderRadius: "50px",
            zIndex: 60,
          }}
        />
      </DialogContent>
    </Dialog>
  );
};
interface ScheduleDemoProps {
  openPopup?: () => void; // Optional prop to open the popup
  onOpenPopup: () => void; // Optional prop to open the popup
  isCalendarOpen: boolean;
  setIsCalendarOpen: React.Dispatch<React.SetStateAction<boolean>>;
}
const ScheduleDemo: React.FC<ScheduleDemoProps> = ({
  openPopup,
  onOpenPopup, // Optional prop to open the popup
  isCalendarOpen,
  setIsCalendarOpen,
}: ScheduleDemoProps) => {
  const openCalendar = () => {
    setIsCalendarOpen(true);
  };
  const [formData, setFormData] = useState<FormData>({
    firstname: "",
    lastname: "",
    email: "",
    companyName: "",
    phone: "",
  });
  //   const navigate = useNavigate(); // ✅ Define navigate inside the component
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const sectionRef = useRef<HTMLDivElement>(null);

  const handleScroll = () => {
    if (sectionRef.current) {
      const { top } = sectionRef.current.getBoundingClientRect();
      const isInView = top < window.innerHeight * 0.5 && top >= 0;
      setIsScrolled(isInView);
    }
  };

  const handleCloseCalendlyPopup = () => {
    setIsPopupOpen(false);
    setFormData({
      firstname: "",
      lastname: "",
      email: "",
      companyName: "",
      phone: "",
    });
    window.location.href = "/success";
  };
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const validateEmail = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>): void => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const handlePhoneChange = (value: string | undefined): void => {
    setFormData({ ...formData, phone: value ?? "" });
  };

  const scheduleDemo = async (event?: React.FormEvent): Promise<void> => {
    event?.preventDefault();
    setIsLoading(true);
    const { email, phone } = formData;

    if (!validateEmail(email)) {
      Swal.fire("Error!", "Email is invalid!", "error");
      setIsLoading(false);
      return;
    }
    if (phone && !isValidPhoneNumber(phone)) {
      Swal.fire("Error!", "Phone number is invalid!", "error");
      setIsLoading(false);
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await fetch("https://prodapi2.legittai.com/api/notification/sendMail", {
        method: "POST",
        body: JSON.stringify({
          firstname: formData.firstname,
          lastname: formData.lastname,
          email: formData.email,
          phone: formData.phone,
          companyName: formData.companyName,
          senderEmail: "gaurav.verma@legittai.com,harshdeep.rapal@legittai.com",
        }),
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
        },
      });

      if (response.ok) {
        // navigate("/schedule-demo", { state: { formData } });
        setIsLoading(false);
      } else {
        Swal.fire(
          "Error!",
          "Something went wrong while sending email. Try again or email at info@legittai.com!",
          "error"
        );
        setIsLoading(false);
      }
    } catch (err) {
      console.error("Error:", err);
      Swal.fire(
        "Error!",
        "Something went wrong while sending email. Try again or email at info@legittai.com!",
        "error"
      );
      setIsLoading(false);
      setFormData({
        firstname: "",
        lastname: "",
        email: "",
        companyName: "",
        phone: "",
      });
    } finally {
      setIsLoading(false);
      setIsSubmitting(false);
    }
  };

  return (
    <Container className="p-[25px] bg-white text-gray-700 rounded-md h-auto w-100%">
      {/* <Box
        component="form"
        noValidate
        autoComplete="off"
        className={`form-container flex flex-col gap-2 ${isScrolled ? "scrolled" : ""}`}
      > */}
      <div className=" flex justify-center p-[5px]  text-gray-700 rounded-xl h-auto   ">
        <GoogleCalendarPopup
          isCalendarOpen={isCalendarOpen}
          setIsCalendarOpen={setIsCalendarOpen}
        />
      </div>
      <div className="flex flex-col justify-center items-center mt-[10px]">
        {/* <DefaultButton
            handleClick={scheduleDemo}
            disabled={isSubmitting || isLoading}
            children="Get A Free Demo"
            isLoading={isLoading}
            size="md"
            style={{
              marginBottom: "8px",
            }}
          /> */}
        <div className="mt-2 text-[0.8rem] lg:text-[0.9rem] font-normal">
          By scheduling demo, you accept our{" "}
          <a
            className="font-semibold text-primary-main"
            style={{ textDecoration: "underline" }}
            href="/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
          >
            privacy policy
          </a>{" "}
          &{" "}
          <a
            className="font-semibold text-primary-main"
            style={{ textDecoration: "underline" }}
            href="/terms-and-conditions"
            target="_blank"
            rel="noopener noreferrer"
          >
            terms and conditions
          </a>
          .
        </div>
      </div>
      {/* </Box> */}
      <Popup
        isOpen={isPopupOpen}
        onClose={handleCloseCalendlyPopup}
        formData={formData} // Pass formData as a prop
        handleCloseCalendlyPopup={handleCloseCalendlyPopup}
      />
    </Container>
  );
};
interface LegittLiteDemoBannerProps {
  isCalendarOpen: boolean;
  setIsCalendarOpen: React.Dispatch<React.SetStateAction<boolean>>;
}
const LegittLiteDemoBanner: React.FC<LegittLiteDemoBannerProps> = ({
  isCalendarOpen,
  setIsCalendarOpen,
}) => {
  const openCalendar = () => {
    setIsCalendarOpen(true);
  };
  const [isScrolled, setIsScrolled] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  const handleScroll = () => {
    if (sectionRef.current) {
      const { top } = sectionRef.current.getBoundingClientRect();
      const isInView = top < window.innerHeight * 0.5 && top >= 0;
      setIsScrolled(isInView);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div>
      <div
        className={`flex flex-wrap mb-[100px] lg:flex-nowrap ${
          isScrolled ? "md:px-[5%] px-[4%]" : "md:px-[4%] px-[4%]"
        } transition-all duration-500 ease-in-out justify-center items-center rounded-lg gap-6`}
        ref={sectionRef}
      >
        <div className="w-full lg:w-[100%] px-2 sm:px-4">
          <div
            className={`relative isolate flex flex-col justify-center items-center overflow-hidden ${
              isScrolled
                ? "bg-gradient-to-b from-[#06526D] to-[#069fc0] text-white"
                : "bg-gray-100 text-gray-700"
            }  py-[50px] rounded-[50px] transition-all duration-300 ease-in-out`}
          >
            <div className=" flex justify-center font-bold text-[36px] sm:text-[44px] lg:text-[40px] mb-[10px] rounded-lg mt-0 ">
              Talk to our Experts
            </div>
            <p className="flex justify-center text-[16px] sm:text-[18px] md:text-[20px] lg:text-[24px] mt-0 mb-6 sm:mb-8 text-center px-2 ">
              Schedule a personalized consultation
            </p>
            <div className="mx-auto px-[15px] md:px-[30px] justify-center items-center lg:px-[50px] xl:px-[50px]">
              <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-6">
                <dl className=" justify-center items-center w-full md:w-[60%] lg:w-[70%] xl:w-[80%]">
                  <div className="w-full">
                    {/* <div className="font-bold text-[36px] sm:text-[44px] lg:text-[40px] mb-[10px] rounded-lg mt-0 ml-0">
                      Talk to our Experts
                    </div>
                    <p className="text-[20px] sm:text-[20px] lg:text-[24px] mt-0 mb-[40px] ml-0">
                      Schedule a personalized consultation
                    </p> */}

                    <div className="mt-6 space-y-4">
                      {/* Step 1 */}
                      <div className="flex items-center space-x-4">
                        <span
                          className={`text-white ${
                            isScrolled ? "bg-black" : "bg-[#06526D]"
                          } min-w-8 max-w-8 h-8 flex items-center justify-center rounded-full font-bold`}
                        >
                          1
                        </span>
                        <p className="text-[16px] sm:text-[14px] md:text-[16px] lg:text-[18px] xl:text-[20px]">
                          Schedule
                        </p>
                      </div>

                      {/* Step 2 */}
                      <div className="flex items-center space-x-4">
                        <span
                          className={`text-white ${
                            isScrolled ? "bg-black" : "bg-[#06526D]"
                          } min-w-8 max-w-8 h-8 flex items-center justify-center rounded-full font-bold`}
                        >
                          2
                        </span>
                        <p className="text-[16px] sm:text-[14px] md:text-[16px] lg:text-[18px] xl:text-[20px] ">
                          Discuss your requirement + See product Demo
                        </p>
                      </div>

                      {/* Step 3 */}
                      <div className="flex items-center justify-top space-x-4">
                        <span
                          className={`text-white ${
                            isScrolled ? "bg-black" : "bg-[#06526D]"
                          } min-w-8 max-w-8 h-8 flex items-center justify-center rounded-full font-bold`}
                        >
                          3
                        </span>
                        <p className="text-left text-[16px] sm:text-[14px] md:text-[16px] lg:text-[18px] xl:text-[20px]">
                          Discover how we can simplify your sales process to
                          <br />
                          save time and close deals faster.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-wrap gap-1 bg-white xs:gap-2 items-center justify-around mt-[50px] sm:mt-[50px] md:mt-[30px] p-2 rounded-[12px] w-[100%] lg:ml-[250px] md:ml-[0px]">
                    <img
                      src="https://d2qb2qddg7l6c6.cloudfront.net/assets/images/ISO27701.png"
                      alt="iso27701"
                      className="w-auto h-[3rem] sm:h-[3.5rem] lg:h-[4rem] xl:h-[5.5rem]"
                      loading="lazy"
                    />
                    <img
                      src="https://d2qb2qddg7l6c6.cloudfront.net/assets/images/ISO27001.png"
                      alt="iso27001"
                      className="w-auto h-[3rem] sm:h-[3.5rem]  lg:h-[4rem] xl:h-[5rem]"
                      loading="lazy"
                    />

                    <img
                      src="https://d2qb2qddg7l6c6.cloudfront.net/assets/images/GdprCertification.png"
                      alt="gdpr"
                      className="w-auto h-[3rem] sm:h-[3.5rem] lg:h-[4rem] xl:h-[5rem]"
                      loading="lazy"
                    />
                    <img
                      src="https://d2qb2qddg7l6c6.cloudfront.net/legitt-website-v5/assets/images/soc_2.png"
                      alt="soc"
                      className="w-auto h-[3rem] sm:h-[3.5rem] lg:h-[4rem] xl:h-[5rem]"
                      loading="lazy"
                    />
                  </div>
                </dl>
                <div
                  className={`bg-white ${
                    isScrolled ? "border-[#37DAFF]" : "border-[#000]"
                  } w-full xs:w-[90%] sm:w-[80%] md:w-[70%] justify-center items-center border-2 mt-6 md:mt-2 lg:mt-0 rounded-[20px] p-2 shadow-lg mb-20 sm:mb-32 lg:mb-40 hover:shadow-xl hover:border-3 transition-all duration-50 ease-linear`}
                >
                  <ScheduleDemo
                    onOpenPopup={() => {
                      console.log("Opening popup");
                    }}
                    isCalendarOpen={isCalendarOpen}
                    setIsCalendarOpen={setIsCalendarOpen}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <SavvyCalDemoPopup /> */}
    </div>
  );
};

export default LegittLiteDemoBanner;
